




































import { defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
export default defineComponent({
  props: {
    tableData: {
      type: Array as () => Array<{ label: string; value: string }>,
      required: false,
      default: () => [],
    },
    applicationsList: {
      type: Array as () => Array<{ group: string; name: string; codeForDisplay: string; fullNameForDisplay: string }>,
      required: false,
      default: () => [],
    },
    reactantsList: {
      type: Array as () => Array<{ codeForDisplay: string; fullNameForDisplay: string }>,
      required: false,
      default: () => [],
    },
    showAbbreviations: {
      type: Boolean,
      required: false,
      default: true,
    },
    useRelatedAndConjugatesUI: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { isEmpty }
  },
})
